import {
  REPORT_ERROR,
  REPORT_LOADING,
  REPORT_SUCCESS,
  RESET_REPORT,
} from "../../../Constants/Constants";

let initialState = {
  getAdminReport: {
    loading: false,
    data: null,
    error: false,
    errors: null,
    success: false,
    pagination: {},
  },
};

export default function ReportReducer(state = initialState, action) {
  switch (action.type) {
    case REPORT_LOADING:
      return {
        ...state,
        getAdminReport: {
          ...state.getAdminReport,
          loading: true,
          error: false,
          errors: [],
          success: false,
          pagination: {},
        },
      };

    case REPORT_SUCCESS:
      return {
        ...state,
        getAdminReport: {
          ...state.getAdminReport,
          loading: false,
          error: false,
          errors: [],
          success: true,
          data: action.response.data,
          pagination: action.response.pagination,
        },
      };

    case REPORT_ERROR:
      return {
        ...state,
        getAdminReport: {
          ...state.getAdminReport,
          loading: false,
          error: true,
          errors: action.errors,
          success: false,
          data: null,
          pagination: {},
        },
      };

    case RESET_REPORT:
      return {
        ...state,
        getAdminReport: {
          ...state.getAdminReport,
          loading: false,
          error: false,
          errors: null,
          success: false,
          pagination: {},
        },
      };

    default:
      return state;
  }
}
